import React, { useEffect, useState, useContext } from "react";
import { strings, translate } from "./../../services/Localization";
import { checkLogin } from "./../../services/Login";
declare const constants;
import {  useParams } from 'react-router-dom';
import { faTrashAlt ,  faRefresh } from '@fortawesome/pro-regular-svg-icons'
import { IUser } from "src/dassTypes";
import {  dialog, dialogDescription } from '../../components/Common';
// import { TAB_PROFILE_EDIT_ACTION, TAB_ADD_DEVICE_PROFILE } from '../../datatypes/tabsconstants'
import AppContext from '../../context/AppContext'
import { BreadCrumbType, PageButtonType } from '../../datatypes/datatypes';
import { ActionType, BulkActionType, ColumnType, DataTableOption,  } from '../../components/Common/DataTable/DataTypes';
import { getLabelBasedOnServerType } from '../../utils/consts';
import { GenericDassQuery } from "../../services/BasicDassQueries";
import { toast } from "./../../utils/Toaster";
import { getVisibleActions, actionIcon, elipsis, dateTimeString } from "./../../utils/filters";
import{ ID_INPUT_VALIDATION, DEFAULT_RECORD_LIMIT }  from "../../components/Common/DataTable/DataTableConsts";
import PageContent from "../PageContent";
import { isMobile } from "react-device-detect";


interface IGlobalProfileState {
    loggedUser: IUser | null;
    showAlertModal: boolean;
    editProfileId: string;
    pageTitle: string;
    breadCrumbArr: BreadCrumbType[];
    refresh: boolean;
    isRowDeleted?: boolean;
}



interface IGlobalProfileRow {
    global_profile_uuid: string;
    profile_name: string;
    description: string;
    vendor: string;
    model: string;
    version: string;
    region: string;
    updated_at: string;
    created_at: string;
    source_userid: string;
    profile_image_url: string;
}



const GlobalProfiles: React.FC = () => {
    const AppContextObj = useContext(AppContext);
    const { id, tabname } = useParams();

    const stateInit: IGlobalProfileState = {
        loggedUser: AppContextObj.user,
        pageTitle: strings.MY_GLOBAL_DEVICE_PROFILES,
        showAlertModal: false,
        editProfileId: '',
        breadCrumbArr: [getLabelBasedOnServerType(strings.GLOBAL_DEVICE_PROFILE, '', ''), { label: strings.GLOBAL_DEVICE_PROFILE, url: '' }],
        refresh: false,
        isRowDeleted: false
    };

    const [profileState, setProfileState] = useState<IGlobalProfileState>(stateInit);

    useEffect(() => {
        if (checkLogin(AppContextObj.user)) {
            setProfileState(prev => ({ ...prev, loggedUser: AppContextObj.user }));
        }
    }, [AppContextObj.user]);

    // const detailPageNav = (profileId: string, row: IGlobalProfileRow) => {
    //     navigate(`${getAppBase()}/global-profiles/${profileId}/${TAB_PROFILE_EDIT_ACTION}`, { state: { row, prevPageUrl: `${getAppBase()}/global-profiles` } });
    // };

    // const detailPageAddNav = () => {
    //     navigate(`${getAppBase()}/global-profiles/${TAB_ADD_DEVICE_PROFILE}`, { state: { prevPageUrl: `${getAppBase()}/global-profiles` } });
    // };

    const deleteProfile = async (profile: IGlobalProfileRow) => {
        const confirmDialogeSettings = {
            title: strings.GLOBAL_PROFILE_DELETE_CONFIRMATION,
            description: profile.global_profile_uuid,
            actionLabel: strings.ACTION_DELETE,
        };
        if (await dialog(confirmDialogeSettings) === true) {
            try {
                await GenericDassQuery(`/rest/global-device-profiles/${profile.global_profile_uuid}`, { method: "DELETE" });
                refreshTable(true);
                toast.success(strings.PROFILE_MSG_DELETE_SUCCESS);
            } catch (e: any) {
                toast.error(e.message);
            }
        }
    };

    const deleteInBulk = async (selectedRows: IGlobalProfileRow[]) => {
        const profileIds = selectedRows.map(row => row.global_profile_uuid);
        if (profileIds.length > 0) {
            const confirmDialogeSettings = {
                title: translate(strings.BULK_DELETE_PROFILE_CONFIRMATION, { count: profileIds.length, uitype: "profile" }) as string,
                description: await dialogDescription(profileIds) + "",
                actionLabel: strings.ACTION_DELETE,
            };
            if (await dialog(confirmDialogeSettings) === true) {
                try {
                    await Promise.all(profileIds.map(profileId =>
                        GenericDassQuery(`/rest/global-device-profiles/${profileId}`, { method: "DELETE" })
                    ));
                    refreshTable(true);
                    toast.success(strings.BULK_DELETE_PROFILE_SUCCESS);
                } catch (e: any) {
                    toast.error(e.message);
                }
            }
        }
    };

    const getActions = () => {
        const actions: ActionType<IGlobalProfileRow>[] = [
            {
                type: "action",
                text: strings.GLOBAL_PROFILE_DELETE,
                visible: () => AppContextObj.user && AppContextObj.user.can_create_device_profile && !AppContextObj.user._readonly,
                render: (row, title) => actionIcon(row.global_profile_uuid, title, faTrashAlt.iconName),
                action: deleteProfile
            }
        ];

        const bulkActions: BulkActionType<IGlobalProfileRow>[] = [
            {
                type: "action",
                text: strings.GLOBAL_PROFILE_DELETE,
                visible: () => AppContextObj.user && AppContextObj.user.can_create_device_profile && !AppContextObj.user._readonly,
                render: (row, title) => actionIcon(row.global_profile_uuid, title, faTrashAlt.iconName),
                action: deleteInBulk
            }
        ];

        return { actions, bulkActions };
    };

    const refreshTable = (isRowDeleted = false) => {
        setProfileState(prev => ({
            ...prev,
            refresh: !prev.refresh,
            isRowDeleted
        }));
    };

    const getColumns = (): ColumnType<IGlobalProfileRow>[] => [
        {
            key: 'bulk_action_checkbox',
            type: "bulk_action_checkbox",
            title: 'Bulk Action',
            filterable: false,
            cellWidth: 3,
            newCellWidth: '30px',
            customClass: 'sticky left-first',
        },
        {
            key: "global_profile_uuid",
            type: "text",
            title: strings.GLOBAL_DEVICE_PROFILE_UUID,
            filterable: true,
            filterField: 'search_by_global_uuid',
            filterType: 'text',
            sortKey: "sort_by_profile_id",
            sortable: true,
            inputValidation: ID_INPUT_VALIDATION,
            filterParams: { mapper: (x) => x || undefined },
            detailLink: true,
            // detailPageNav: (row: IGlobalProfileRow) => detailPageNav(row.global_profile_uuid, row),
            dataAlign: 'left',
            extraClass: 'ow-datatable-overflow-ellipsis',
            newCellWidth: isMobile ? '250px' : "30%",
            minWidth: 180,
            maxWidth: 320,
            flex: 1,
            resizable: true,
            showCopyLink: true,
        },
        {
            key: "profile_name",
            title: strings.TABLE_PROFILE_NAME,
            type: "text",
            filterable: true,
            filterField: 'search_profile_name',
            filterType: 'text',
            filterParams: { mapper: (x) => x || undefined },
            newCellWidth: '60%',
            width: 220,
            minWidth: 180,
            flex: 2,
            resizable: true,
        },
        {
            key: "description",
            title: strings.DESCRIPTION,
            type: "text",
            filterable: true,
            filterField: 'search_description',
            filterType: 'text',
            filterParams: { mapper: (x) => x || undefined },
            render: (row) => elipsis(row.description, 50),
            render_tooltip: (row) => row.description,
            newCellWidth: '60%',
            width: 260,
            minWidth: 180,
            flex: 2,
            resizable: true,
        },
        {
            key: "vendor",
            title: strings.VENDOR,
            type: "text",
            filterable: true,
            filterField: 'search_vendor',
            filterType: 'text',
            filterParams: { mapper: (x) => x || undefined },
            newCellWidth: '60%',
            width: 140,
            minWidth: 100,
            flex: 1,
            resizable: true,
        },
        {
            key: "model",
            title: strings.MODEL,
            type: "text",
            filterable: true,
            filterField: 'search_model',
            filterType: 'text',
            filterParams: { mapper: (x) => x || undefined },
            newCellWidth: '60%',
            width: 140,
            minWidth: 100,
            flex: 1,
            resizable: true,
        },
        {
            key: "region",
            title: strings.TABLE_REGION,
            type: "text",
            newCellWidth: '60%',
            width: 120,
            minWidth: 100,
            flex: 1,
            resizable: true,
        },
        {
            key: "updated_at",
            title: strings.LAST_UPDATE,
            type: "text",
            sortable: true,
            sortKey: "sort_by_updated_at",
            render: (row) => dateTimeString(row.updated_at),
            render_tooltip: (row) => row.updated_at,
            newCellWidth: '60%',
            width: 180,
            minWidth: 140,
            flex: 1,
            resizable: true,
        },
        {
            key: "created_at",
            title: strings.CREATED_AT,
            type: "text",
            sortable: true,
            sortKey: "sort_by_created_at",
            render: (row) => dateTimeString(row.created_at),
            render_tooltip: (row) => row.created_at,
            newCellWidth: '60%',
            width: 180,
            minWidth: 140,
            flex: 1,
            resizable: true,
        },
        {
            key: 'action_button',
            type: "action_button",
            title: "actions",
            filterable: false,
            cellWidth: 3,
            newCellWidth: "140px",
            customClass: 'sticky right',
        }
    ];

    const getDataTableOptions = (): DataTableOption<IGlobalProfileRow> => {
        const { actions, bulkActions } = getActions();
        return {
            url: '/uiapi/rest/global-device-profiles',
            query_param: { all: true, get_pages: true, limit: DEFAULT_RECORD_LIMIT, stream: 'progress', get_list: true } as any,
            serial_number: false,
            id_field: 'global_profile_uuid',
            oboe_path: 'pages.*',
            available_key: 'global_profile_uuid',
            emptyDataMsg: strings.NO_GLOBAL_PROFILE_AVAILABLE,
            modal: false,
            columns: getColumns(),
            actions,
            bulkActions: getVisibleActions(bulkActions)
        };
    };

    const getPageButtons = (): PageButtonType[] => [
        {
            title: strings.REFRESH_LIST,
            action: () => refreshTable(),
            type: 'button',
            icon: faRefresh
        },
        {
            title: 'separator',
            type: 'separator',
        }
    ];

    return (
        <PageContent
            name="global-profiles"
            id={id}
            tabname={tabname}
            actions={getActions()}
            breadCrumbArr={profileState.breadCrumbArr}
            pageButtons={getPageButtons()}
            countLabel={strings.GLOBAL_DEVICE_PROFILE}
            dataTableOption={getDataTableOptions()}
            isRowDeleted={profileState.isRowDeleted}
            refresh={profileState.refresh}
        />
    );
}

export default GlobalProfiles;